/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable max-len */

import { Menu } from '@headlessui/react'
import React, { useState, useEffect } from 'react';
import 'react-loading-skeleton/dist/skeleton.css'
import { Link, useLocation, useNavigate , useParams} from 'react-router-dom';
import config from '../../../config';

import { useDispatch } from 'react-redux';
import PublishLiveAuctionModal from './PublishLiveAuctionModal';
import UnPublishAuctionModal from './unpublishAuctionModal';
import { dataService } from '../../../services/dataService';
import { getAuctionStatusClasses } from '../../../constant/auctionStatusClasses';
import Modal from '../../../CommonComponent/Modal';
import scrollToTop from '../../../CommonComponent/scrollToTop';
import ToolTip from '../../../CommonComponent/tooltip';

export default function LiveAuctionHeader({auctionData, cloneHandler, handleView, domain, bidInformation, bidsInfo,setMessage, setUploadErrorMessage}){
    const state = useLocation();
    const {id, uid} = useParams();
    const Navigate=useNavigate();

    const [publishModalOpen, setPublishModalOpen] = useState(false);
    const [unpublishModalOpen,setUnpublishModalOpen]= useState(false); 
    const [isDeleteModalOpen,setIsDeleteModalOpen] = useState(false);
    const [loader, setLoader] = useState(false);
    const [loaderStats, setLoaderStats] = useState(false);
    const [notConnect, setNotConnect]=useState(null)
    const user = (localStorage.getItem('user'));
    const [isRequiredFieldEmpty, setIsRequiredFieldEmpty] = useState(false)
    const [noLot,setNoLot]=useState(false);
    const [publishLoader,setPublishLoader] = useState(false)
    const [isPublished, setIsPublished] = useState(false)
    const dispatch = useDispatch()
    const [isOpen, setIsOpen] = useState(false);
    const [loading , setLoading] = useState(false);
    const [isOpenCancel, setIsOpenCancel] = useState(false);
    const [statistics, setStatistics] = useState(null);
    const plan_type=localStorage.getItem('plan_type');

    const handleTemplate=(template)=>{
        if(template==="Classic"){
            localStorage.setItem('selectedTemplateId','1')
            return "classic";
        }else if(template==="" || template==="Single lot" || template==="Single Lot"){
            localStorage.setItem('selectedTemplateId','2')
            return "single-lot";
        }else if(template==="Standalone"){
            localStorage.setItem('selectedTemplateId','3')
            return "standalone";
        }
    }

    const tooltipContent = ()=>{
        switch(auctionData.status){
        case "Published":
            return "The live auction page can be shared with your audience. Absentee and/or telephone bids can be accepted.";
        case "In Progress":
            return "Your live auction has now begun. Pre-bidding has now closed.";
        case "Completed":
            return "Your auction has ended. Please follow up with your absentee bidders to update them on their bids.";
        default:
            return "";
        }
    }
    
    const handlePublishAuction = async(auctionId)=>{
        setPublishLoader(true)
    
        const body = {
            "auction_id": auctionId,
            "seller_email": user
        }
        if(!((auctionData.auction_image =="" || auctionData.title=="" || auctionData.description=="" || auctionData.currency=="" ) || 
            (auctionData.start_date =="" || auctionData.time_zone==""  || auctionData.start_date ==null ) || 
            (auctionData.registration_type=="" || ((auctionData.add_buyer_fees =="Add percentage"  && auctionData.percentage=="") || ( auctionData.add_buyer_fees=="Add fixed fee" 
            && auctionData.fees=="" ) )) || auctionData.accept_absentee_bid==null || auctionData.accept_telephone_bid==null) ){
                
            if(auctionData.total_lots > 0){
                const data = await dataService.PublishLiveAuction(body)
                if(data.error==true){
                    const errorMessage = data.message.response.data.message;
    
                    switch (errorMessage) {
                    case "Auction not in draft state":
                        setUploadErrorMessage("Auction is already in Published State");
                        setPublishModalOpen(false);
                        handleView();
                        setTimeout(() => {
                            setUploadErrorMessage("");
                        }, 3000);
                        break;
    
                    case "No images found for this auction":
                        setPublishModalOpen(false);
                        setIsRequiredFieldEmpty(true);
                        setNoLot(true);
                        break;
    
                    case "Stripe or PayPal account is not linked.":
                        setNotConnect("stripe");
                        setPublishModalOpen(false);
                        setIsRequiredFieldEmpty(true);
                        break;
    
                    case "Unauthorised to perform this action.":
                        Auth.signOut();
                        dispatch(logout());
                        dispatch(clearData());
                        localStorage.clear();
                        Navigate("/login");
                        break;
    
                    default:
                        if (errorMessage.includes("verification")) {
                            setNotConnect("verification");
                            setPublishModalOpen(false);
                            setIsRequiredFieldEmpty(true);
                        } else {
                            setUploadErrorMessage(errorMessage);
                            setPublishModalOpen(false);
                            setTimeout(() => {
                                setUploadErrorMessage("");
                            }, 30000);
                        }
                        break;
                    }
    
                }else{
                    setUploadErrorMessage("")
                    setIsPublished(true)
                    setPublishModalOpen(false)
                    setPublishLoader(false)
                    handleView()
                }
            }else{
                setPublishModalOpen(false)
                setIsRequiredFieldEmpty(true)
            }
        }else{
            setPublishModalOpen(false)
            setIsRequiredFieldEmpty(true)
        }
    
        setPublishLoader(false)
    }

    const handleUnpublishAuction = async(auctionId)=> {
        setPublishLoader(true)
        const body={
            "auction_id": auctionId,
            "seller_email": user
        }
        const data = await dataService.UnpublishLiveAuction(body)
        setUnpublishModalOpen(false)
        setPublishLoader(false)
        scrollToTop();
        if(data.error==true){
            if(data?.message?.response?.data?.message){
                setUploadErrorMessage(data?.message?.response?.data?.message)
                setTimeout(()=>{
                    setUploadErrorMessage("")
                },30000)
            }else{
                setUploadErrorMessage('Something went wrong. Please try again')
                setTimeout(()=>{
                    setUploadErrorMessage("")
                },3000)
            }
        }else{
            setUploadErrorMessage('');
            setMessage('Auction unpublished successfully')
            setTimeout(()=>{
                setMessage("")
            },3000)
        }
        handleView()
    }

    const handleCompleteAuction =async()=>{
        setLoading(true);
        const body={
            "auction_id": uid,
            "status": "Completed"
        }
        const response = await dataService.CompleteAuction(body)
        setLoading(false);
        setIsOpen(false);
        if(response.error==false){
            handleView();
        }else{
            if(response?.message && response.message.status==400){
                console.log(response, 'response')
                setUploadErrorMessage(response?.message?.data?.message)
                handleView();
            }else{
                setUploadErrorMessage('Something went wrong. Please try again')
            }
            setTimeout(()=>{
                setUploadErrorMessage("")
            },4000)
        }
    }

    const handleDelete = async() => {
        setLoader(true)
        try {
        // Safely check if auction_type exists and equals 'live'
            const isLive = auctionData?.auction_type === 'live';
            const data = await dataService.DeleteAuction(uid, isLive);
            setIsDeleteModalOpen(false)
            if(data.error === false) {
                Navigate('/auctions')
                localStorage.setItem('AuctionDelete', 'success');
            } else {
                if(data?.message && data.message.status==400){
                    setUploadErrorMessage(data?.message?.data?.message)
                    handleView();
                }else{
                    setIsDeleteModalOpen(false)
                    setUploadErrorMessage('Failed to delete auction. Please try again.');
                }
                setTimeout(() => {
                    setUploadErrorMessage('');
                }, 5000);
                
            }
        } catch (error) {
            setIsDeleteModalOpen(false)
            setUploadErrorMessage('An unexpected error occurred. Please try again.');
            setTimeout(() => {
                setUploadErrorMessage('');
            }, 5000);
        } finally {
            setLoader(false)
        }
    }

    const handleCancelAuction = async()=>{
        setLoading(true);
        const body={
            "auction_id": uid,
            "seller_email": user
        }
        const response = await dataService.CancelAuction(body)
        setLoading(false);
        setIsOpenCancel(false);
        if(response.error==false){
            handleView();
            setMessage('Auction has successfully been cancelled')
            setTimeout(()=>{
                setMessage("")
            },3000)
        }else{
            if(response?.message && response.message.status==400){
                setUploadErrorMessage(response?.message?.data?.message)
                handleView();
            }else{
                setUploadErrorMessage('Something went wrong. Please try again')
            }
            setTimeout(()=>{
                setUploadErrorMessage("")
            },4000)
        }
    }

    const handleAuctionStats = async () => {
        setLoaderStats(true);
        const response = await dataService.AuctionStats({ auction_id: uid });

        if (!response?.error) {
            setStatistics(response?.data); // store the API response
        } else {
            console.error("AuctionAnalytics error:", response.message);
        }

        setLoaderStats(false);
    };

    useEffect(() => {
        handleAuctionStats();
    }, []);


    return(
        <>
            <div className="flex justify-between items-center mt-8 sm:flex-row flex-col">
                <div className='sm:w-auto w-full relative'>
                    <div className='flex gap-1 items-center gap-3' >
                        <div data-testid="status" 
                            className={`flex gap-1 justify-center items-center min-w-[96px] w-fit relative py-[8px] mb-3 px-[16px] text-[12px] 
                                ${getAuctionStatusClasses(auctionData.status)} 
                                rounded-[42px] text-end leading-normal font-semibold`}>
                            {auctionData.status==='Accepting bids' || auctionData.status==='In Progress' &&
                            <img className="" src="/images/green-dot.svg" alt="img" />}
                            {auctionData.status}
                        </div>
                        {auctionData.status!=="Draft" && auctionData.status!=="Cancelled" && <ToolTip trigger="click"
                            content={tooltipContent()} tooltipTestId="status-tooltip-content">
                            <img src="/images/info-icon.svg" className="cursor-pointer w-[17px] mb-3" 
                                data-testid='status-tooltip-icon' alt="info-icon" loading="lazy" />
                        </ToolTip>}
                    </div>
                    <p id="auction-title" className="sm:text-[34px] text-[20px]  font-medium leading-normal text-[#343434] sm:pt-0 pt-3.5">
                        {auctionData.title===''?'Auction title goes here': (auctionData?.title?.length > 50 ? auctionData?.title?.substring(0, 50) + '...' : auctionData?.title) }</p>
                    <div className='flex gap-1 absolute bottom-[-8px]' >
                        <img src="/images/gavel.svg" />
                        <span className='text-[10px] text-[#717179]' data-testid='live-auction-header'>Live Auction</span>
                    </div>
                </div>
                <div className="flex sm:mt-0 mt-3 sm:w-auto w-full sm:justify-start justify-end">
                    {(auctionData.status!=='Cancelled' ) && 
                    <>
                        {(auctionData.status==='Published' || auctionData.status=== 'Completed' || auctionData.status === "In Progress" ) &&
                        <Link type='button' target='_blank' data-testid="view_preview" to={`https://${domain}.${config.Environment.domain}/auctions/${auctionData._id}?isPreview=true`}
                            className="sx:px-[31px] px-5 py-[12px] bg-[#FFFFFF] mr-3 text-[#52525A] 
                            leading-normal border border-[rgb(161,161,169)] font-medium text-[14px] rounded-[6px] hover:bg-[#A1A1A9] hover:text-[#FFFFFF]">
                            View Auction
                        </Link>
                        }
                        {(auctionData.status=='Draft' || auctionData.status=='Published') && 
                        <button id='edit-auction' type='button'
                            onClick={()=>{
                                Navigate(`/auctions/live/edit/${id}/${uid}/${handleTemplate(auctionData?.template_name)}`,
                                    {state: auctionData===undefined? '' : {start_date: auctionData.start_date, end_date: auctionData.end_date, location: auctionData.location }})
                            }} 
                            className="sx:px-[31px] px-5 py-[12px] bg-[#FFFFFF] mr-3 text-[#52525A] 
                                leading-normal border border-[#A1A1A9] font-medium text-[14px] rounded-[6px] hover:bg-[#A1A1A9] hover:text-[#FFFFFF]">
                            Edit
                        </button>}
                                    
                        {auctionData.status=='Draft' &&
                        <button data-testid="publish-auction" 
                            className="sx:px-[31px] px-5 py-[12px] bg-[#282828] mr-2 text-[#FFFFFF] hover:bg-[#3F3F45]
                                leading-normal font-medium text-[14px] rounded-[6px]"  onClick={() => {
                                auctionData.status==='Published' ? setUnpublishModalOpen(true) : setPublishModalOpen(true)
                            }}>
                            Publish
                        </button> }
                    </>
                    }
                    {(auctionData.status!=='Completed' && auctionData.status!=='Cancelled') && <Menu as="div" className="flex items-center relative " id="menu_id">
                        <Menu.Button className="relative" data-te-dropdown-ref>
                            <img src="/images/three-dots-icon-black.svg" alt="img" className="cursor-pointer"  data-testid="three-dots" type="button"
                                id="dropdownMenuButton1"
                                data-te-dropdown-toggle-ref
                                aria-expanded="false"/>
                        </Menu.Button>
                        <Menu.Items 
                            className="absolute top-[50px] right-0 z-50 float-left m-0 w-[145px] py-2 min-w-max list-none 
                                        overflow-hidden px-2
                                            rounded-[10px] border-none bg-white bg-clip-padding text-left text-base shadow-bs3 
                                            [&[data-te-dropdown-show]]:block"
                            aria-labelledby="dropdownMenuButton2">
                            {/* {(auctionData.status!=="Accepting bids" && auctionData.status!=="Cancelled") && <Menu.Item>
                                <button 
                                    disabled={plan_type.includes("Free")}
                                    className="disabled:text-[hsl(240,4%,65%)] disabled:cursor-auto block 
                                                                    w-full whitespace-nowrap bg-transparent pl-3 pr-5 text-left hover:bg-[#E6E6E6] hover:rounded-[11px]
                                                                        py-2 text-[12px] font-medium text-[#343434] cursor-pointer"
                                >Clone</button>
                            </Menu.Item> } */}
                            {auctionData.status ==='Draft' &&
                            <Menu.Item>
                                <button type='button' 
                                    disabled={auctionData.status!=="Draft"}
                                    data-testid="delete-auction"
                                    onClick={()=>{setIsDeleteModalOpen(true)}}
                                    className="cursor-pointer block w-full whitespace-nowrap bg-transparent pl-3 pr-5 
                                                            py-1.5 text-[12px] text-left hover:bg-[#E6E6E6] hover:rounded-[11px]
                                                                font-medium text-[#343434]"
                                >Delete</button>
                            </Menu.Item>}
                            {auctionData.status==='Published'&&
                            <Menu.Item>
                                <button data-testid="publish-auction"
                                    className="cursor-pointer block w-full whitespace-nowrap bg-transparent pl-3 pr-5 
                                                py-1.5 text-[12px] hover:bg-[#E6E6E6] hover:rounded-[11px] text-left
                                                    font-medium text-[#343434]"
                                    onClick={() => setUnpublishModalOpen(true)}
                                >Unpublish</button>
                            </Menu.Item>}  
                            {/* {auctionData.status!=='Completed' &&
                            <Menu.Item>
                                <button type='button' 
                                    data-testid="delete-auction"
                                    className="cursor-pointer block w-full whitespace-nowrap bg-transparent pl-3 pr-5 
                                                py-1.5 text-[12px] text-left hover:bg-[#E6E6E6] hover:rounded-[11px]
                                                    font-medium text-[#343434]"
                                >Delete</button>
                            </Menu.Item>}*/}
                            {auctionData.status=='In Progress' &&
                            <>
                                <Menu.Item>
                                    <button type='button' 
                                        onClick={()=>setIsOpen(true)}
                                        data-testid="complete-auction"
                                        className="cursor-pointer block w-full whitespace-nowrap bg-transparent pl-3 pr-5 
                                                py-1.5 text-[12px] text-left hover:bg-[#E6E6E6] hover:rounded-[11px]
                                                    font-medium text-[#343434]"
                                    >Mark as completed</button>
                                </Menu.Item>
                                <Menu.Item>
                                    <button type='button' 
                                        onClick={()=>setIsOpenCancel(true)}
                                        data-testid="cancel-auction"
                                        className="cursor-pointer block w-full whitespace-nowrap bg-transparent pl-3 pr-5 
                                                py-1.5 text-[12px] text-left hover:bg-[#E6E6E6] hover:rounded-[11px]
                                                    font-medium text-[#343434]"
                                    >Cancel auction</button>
                                </Menu.Item>
                            </>}
                        </Menu.Items>
                    </Menu>}
                </div>
                {/* <!-- box content --> */}
            </div>
            <div className="flex ss:flex-nowrap flex-wrap mt-6">
                <div className="ss:w-1/3 w-full min-h-[99px] lg:px-10 px-5 pt-3 ss:mb-0 mb-2.5 rounded-[20px] bg-[#B8D5DB]">
                    <p className="text-[12px] leading-normal font-semibold text-[#52525A]">NUMBER OF ACTIVE BIDDERS</p>
                    <p className="xmd:text-[30px] md:text-[20px] text-[30px] lg:text-[34px] leading-normal font-bold text-[#282828] truncate" 
                        data-testid='activeBidders' title={statistics?.statistics.number_of_active_bidders ?? 0}>
                        {loaderStats? 
                            <p className='md:w-[30%] w-full animate-pulse h-10 bg-[#dbd9d9f3] mt-2'></p>
                            :
                            statistics?.statistics.number_of_active_bidders ?? 0}
                    </p>
                </div>
                <div className=" ss:w-1/3 w-full min-h-[99px] px-5 lg:px-10 pt-3 ss:mx-5 ss:mb-0 mb-2.5 rounded-[20px] bg-[#DDD1D5]">
                    <p className="text-[12px] leading-normal font-semibold text-[#52525A]">SUM OF ABSENTEE BIDS</p>
                    <p className="text-[30px] lg:text-[34px] leading-normal font-bold text-[#282828] truncate" 
                        title={Number(statistics?.statistics.sum_of_absentee_bids ?? 0).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                            style: 'currency',
                            currency: auctionData.currency,
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })}
                        data-testid='absenteeBids'>
                        {loaderStats? 
                            <p className='md:w-[30%] w-full animate-pulse h-10 bg-[#dbd9d9f3] mt-2'></p>
                            :
                            Number(statistics?.statistics.sum_of_absentee_bids ?? 0).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                                style: 'currency',
                                currency: auctionData.currency,
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })}
                    </p>
                </div>
                <div className="ss:w-1/3 w-full min-h-[99px] px-5 lg:px-10 pt-3 rounded-[20px] ss:mb-0 mb-2.5 bg-[#ECD6C7]">
                    <p className="text-[12px] leading-normal font-semibold text-[#52525A]">NUMBER OF TELEPHONE BIDS</p>
                    <p 
                        className="text-[30px] lg:text-[34px] leading-normal font-bold text-[#282828] truncate"
                        data-testid="telephoneBid" title={statistics?.statistics.number_of_telephone_bids ?? 0}
                    >
                        {loaderStats? 
                            <p className='md:w-[30%] w-full animate-pulse h-10 bg-[#dbd9d9f3] mt-2'></p>
                            :statistics?.statistics.number_of_telephone_bids ?? 0}
                    </p>

                </div>
            </div>

            <PublishLiveAuctionModal notConnect={notConnect} publishModalOpen={publishModalOpen} setPublishModalOpen={setPublishModalOpen} 
                handlePublishAuction={handlePublishAuction} loader={publishLoader} selectedId={auctionData.auction_id}
                auctionData={auctionData} isRequiredFieldEmpty={isRequiredFieldEmpty} domain={domain} noLot={noLot}
                setIsRequiredFieldEmpty={setIsRequiredFieldEmpty} isPublished={isPublished} setIsPublished={setIsPublished} />
            
            <Modal setIsOpen={setIsOpen} isOpen={isOpen} handleAction={handleCompleteAuction} loading={loading} 
                buttonText="Complete" id="cancel-button" testid="confirm-complete-auction"
                title="Are you sure you want to complete this auction?"
                description="Please note that once an auction is completed it cannot be undone. All bidder and bids data will be retained."
            />

            <Modal setIsOpen={setIsOpenCancel} isOpen={isOpenCancel} handleAction={handleCancelAuction} loading={loading} 
                buttonText="Cancel auction" id="cancel-button" testid="confirm-cancel-auction" close={true} notShowCancel={true}
                title="Are you sure you want to cancel the auction?"
                description="Please note that cancelled auctions cannot be re-published. All bidder and bids data will be retained."
            />

            <UnPublishAuctionModal notConnect={notConnect} unpublishModalOpen={unpublishModalOpen} setUnpublishModalOpen={setUnpublishModalOpen} 
                handleUnpublishAuction={handleUnpublishAuction} loader={publishLoader} selectedId={auctionData.auction_id} />
            

            <Modal setIsOpen={setIsDeleteModalOpen} isOpen={isDeleteModalOpen} handleAction={handleDelete} loading={loader} 
                buttonText="Delete" id="delete-button" close={false} notShowCancel={false}
                title="Are you sure you want to delete the auction?"
                description="Please note that deleting the auction will also delete all lots within the auction. This action cannot be reversed."
            />
        </>
    );
}